// Neutral bootstrap state. Texts, sources, counts, collections, topics, and
// shelves are replaced by live BFF responses; no representative corpus data is
// embedded in the client.
const SICHA = {
  id: "", collection: "", volume: "", parsha: "", titleHe: "", titleEn: "",
  subtitleEn: "", meta: { sources: 0, quotedSources: 0, words: 0, readMins: 0, translated: false },
  segments: [], versionsAvailable: {}, versionDetails: [], selectedVersions: {},
};
const SOURCES = [];

const SOURCE_TYPES = {
  Tanach: { key: "tanach", label: "Tanach" },
  Mishnah: { key: "mishnah", label: "Mishnah" },
  Gemara: { key: "gemara", label: "Gemara" },
  Midrash: { key: "midrash", label: "Midrash" },
  Halacha: { key: "halacha", label: "Halacha" },
  Kabbalah: { key: "kabbalah", label: "Kabbalah" },
  Chassidus: { key: "chassidus", label: "Chassidus" },
  Rebbe: { key: "rebbe", label: "The Rebbe" },
  Other: { key: "rebbe", label: "Other" },
};

const CONTINUE = [];
const COLLECTIONS = [];
const TOPICS = [];
const TODAY = { hayomyom: { date: "", he: "", en: "", ref: "" }, parsha: "" };
const WEEKLY_FEATURE = null;
const MAYANOS_SPONSORSHIP = {
  label: "Today's learning is sponsored",
  name: "יעקב קלמן בן אלטר יהושע הכהן",
  compact: "לע״נ יעקב קלמן בן אלטר יהושע הכהן",
};

// Corpus exports occasionally contain editorial markers from the source
// database. They are useful to the ingestion pipeline, but should never leak
// into the reading surface (for example, [dibur\\_maschil]…[/dibur\\_maschil]).
function cleanMayanosMarkup(value) {
  return String(value || "")
    // These two wrappers mark text that the reader already supports as bold.
    .replace(/\[(?:dibur\\?_maschil|headingintext\\?_begin)\]/gi, "**")
    .replace(/\[(?:\/(?:dibur\\?_maschil|headingintext\\?_end)|headingintext\\?_end|(?:dibur\\?_maschil|headingintext\\?_end)\s*\/)\]/gi, "**")
    // Single-star emphasis is used by the Toras Menachem source export.
    // Do not consume standalone footnote stars, multiplication, or double stars.
    .replace(/(?<![\w\\])(?:\*\*([^*]+?)\*\*|\*([^*\s\\](?:[^*\n\\]*?[^*\s\\])?)\*(?!\w))/gu, (match, double, single) => double !== undefined ? match : "**" + single + "**")
    // Other known corpus wrappers carry structure without a reader style.
    // Keep their enclosed text, and accept both [/tag] and malformed [tag/].
    .replace(/\[\/?(?:dibur\\?_maschil|headingintext\\?_begin|headingintext\\?_end|zman\\?_begin|zman\\?_end|tochen\\?_begin|tochen\\?_end|small\\?_begin|small\\?_end|pianuach|reshimo|reshimo\\?_inline|kitzur\\?_begin|kitzur\\?_end|oldpage\\?_734)\s*\/?\]/gi, "")
    .replace(/\\_/g, "_")
    .replace(/\[\/?(?:footnote|quote)\]/gi, "")
    .replace(/\s+/g, " ")
    .trim();
}

// Biographical labels are navigation chrome; every works shelf is live.
const REBBEIM = [
  { id: "alter", ac: "אדה״ז", he: "כ״ק אדמו״ר הזקן", en: "The Alter Rebbe", full: "R’ Schneur Zalman of Liadi", years: "1745–1812", epithet: "Baal HaTanya · founder of Chabad", works: [] },
  { id: "mitteler", ac: "אדהאמ״צ", he: "כ״ק אדמו״ר האמצעי", en: "The Mitteler Rebbe", full: "R’ Dovber of Lubavitch", years: "1773–1827", epithet: "The second Chabad Rebbe", works: [] },
  { id: "tzemach", ac: "צ״צ", he: "כ״ק אדמו״ר הצמח צדק", en: "The Tzemach Tzedek", full: "R’ Menachem Mendel Schneersohn", years: "1789–1866", epithet: "The third Chabad Rebbe", works: [] },
  { id: "maharash", ac: "מהר״ש", he: "כ״ק אדמו״ר מהר״ש", en: "The Rebbe Maharash", full: "R’ Shmuel Schneersohn", years: "1834–1882", epithet: "The fourth Chabad Rebbe", works: [] },
  { id: "rashab", ac: "רש״ב", he: "כ״ק אדמו״ר מהורש״ב", en: "The Rebbe Rashab", full: "R’ Sholom Dovber Schneersohn", years: "1860–1920", epithet: "The fifth Chabad Rebbe", works: [] },
  { id: "rayatz", ac: "ריי״צ", he: "כ״ק אדמו״ר מהוריי״צ", en: "The Frierdiker Rebbe", full: "R’ Yosef Yitzchak Schneersohn", years: "1880–1950", epithet: "The sixth Chabad Rebbe", works: [] },
  { id: "rebbe", ac: "הרבי", he: "כ״ק אדמו״ר שליט״א", en: "The Lubavitcher Rebbe", full: "R’ Menachem Mendel Schneerson", years: "1902–1994", epithet: "The seventh Chabad Rebbe", works: [] },
];
const EARLY_CHASSIDUS = [
  { id: "besht", ac: "בעש״ט", he: "הבעש״ט", en: "The Baal Shem Tov", full: "R’ Yisrael ben Eliezer", years: "c. 1700–1760", epithet: "Founder of the Chassidic movement", works: [] },
  { id: "maggid", ac: "מגיד", he: "הרב המגיד", en: "The Maggid of Mezritch", full: "R’ Dov Ber of Mezritch", years: "d. 1772", epithet: "Successor to the Baal Shem Tov", works: [] },
];
const NIGLA = [];

Object.assign(window, { SICHA, SOURCES, SOURCE_TYPES, CONTINUE, COLLECTIONS, TOPICS, TODAY, WEEKLY_FEATURE, MAYANOS_SPONSORSHIP, REBBEIM, EARLY_CHASSIDUS, NIGLA, cleanMayanosMarkup });
